import * as React from 'react';
import {
  Cube24Regular,
  Building24Regular,
  People24Regular,
  Warning24Regular,
  ClipboardTask24Regular,
  Apps24Color,
  Briefcase24Regular,
  CalendarArrowCounterclockwise24Regular,
  PeopleTeamRegular,
  TaskListSquarePerson24Regular,
  DocumentText24Regular,
  BuildingMultiple24Regular,
} from '@fluentui/react-icons';

export const getEntityIcon = (entity: string): React.ReactNode => {
  switch (entity.toLowerCase()) {
    case 'asset':
      return <Cube24Regular style={{ color: 'green' }} />;
    case 'zone':
      return <Building24Regular style={{ color: 'goldenRod' }} />;
    case 'renter':
    case 'rent':
      return (
        <CalendarArrowCounterclockwise24Regular
          style={{ color: 'dodgerBlue' }}
        />
      );
    case 'contractor':
      return (
        <TaskListSquarePerson24Regular style={{ color: 'darkGoldenRod' }} />
      );
    case 'issue':
      return <Warning24Regular style={{ color: 'salmon' }} />;
    case 'work':
      return <Briefcase24Regular style={{ color: 'mediumBlue' }} />;
    case 'order':
      return <ClipboardTask24Regular style={{ color: 'blueViolet' }} />;
    case 'user':
      return <People24Regular style={{ color: 'purple' }} />;
    case 'group':
      return <PeopleTeamRegular style={{ color: 'purple' }} />;
    case 'report':
      return <DocumentText24Regular style={{ color: 'teal' }} />;
    case 'tenant':
      return <BuildingMultiple24Regular style={{ color: 'chocolate' }} />;
    default:
      return <Apps24Color style={{ color: 'gray' }} />;
  }
};

// Derive an entity token from a prefixed code/name by taking the first segment
// and singularizing it, e.g. "ASSETS_BARCHART" -> "asset",
// "CONTRACTOR_COUNT" -> "contractor". Lets dashboard component codes resolve to
// the same entity icons as the metadata entity dropdown.
export const getEntityFromCode = (code: string): string => {
  const first = (code ?? '').split('_')[0]?.toLowerCase() ?? '';
  return first.endsWith('s') ? first.slice(0, -1) : first;
};

// Icon for a prefixed component/entity code, reusing the shared entity-icon
// mapping above (no duplicate icon tables).
export const getEntityIconForCode = (code: string): React.ReactNode =>
  getEntityIcon(getEntityFromCode(code));

interface EntityCellProps {
  entity: string;
}

/**
 * Entity icon + label, shared by the metadata list table column, the metadata
 * editor, and the create-form preview so all three render entities identically.
 */
const EntityCell = ({ entity }: EntityCellProps) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
    {getEntityIcon(entity)}
    <span>{entity}</span>
  </div>
);

export default EntityCell;
